import { Outlet, useLocation } from 'react-router-dom';
import MonitorSidebar from './MonitorSidebar';
import MonitorHeader from './MonitorHeader';

const PAGE_TITLES: Record<string, string> = {
  '/monitor/dashboard': 'Mi Dashboard',
  '/monitor/agenda': 'Mi Agenda',
  '/monitor/gym': 'Preparación Física',
  '/monitor/evaluaciones': 'Evaluaciones',
  '/monitor/comunicaciones': 'Comunicaciones',
  '/monitor/notificaciones': 'Mis Avisos',
};

export default function MonitorLayout() {
  const location = useLocation();
  const isSessionDetail = location.pathname.startsWith('/monitor/sesion');
  const isGymAlumno = location.pathname.match(/^\/monitor\/gym\/.+/);
  const basePath = isSessionDetail
    ? '/monitor/agenda'
    : isGymAlumno
      ? '/monitor/gym'
      : location.pathname;
  const title = isSessionDetail
    ? 'Detalle de Sesión'
    : isGymAlumno
      ? 'Preparación Física — Alumno'
      : (PAGE_TITLES[basePath] ?? 'VERTEX Performance');

  return (
    <div className="flex min-h-screen bg-bg-primary">
      <MonitorSidebar />
      <div className="flex-1 ml-64 flex flex-col">
        <MonitorHeader title={title} />
        <main className="mt-16 p-8 flex-1">
          <Outlet />
        </main>
        <footer className="px-8 py-4 text-center text-text-secondary text-xs font-inter opacity-60 tracking-wider">
          by Cognix Labs
        </footer>
      </div>
    </div>
  );
}
